// AudioPlayerEngine — headless host для useMiniPlayer().
//
// useMiniPlayer создаёт единственный <audio> на жизненный цикл приложения
// и связывает его со store (loadedmetadata → duration, timeupdate → position,
// isPlaying → play/pause, seek/speed/volume). Хук подписан на весь store и
// ре-рендерится на каждый timeupdate (~4 Гц), поэтому изолируем его в отдельном
// компоненте, который рендерит null — ре-рендеры не доходят до layout-дерева.
//
// Монтируется один раз в __root.tsx (см. rules/frontend-ui.md §23 — глобальный
// аудио-плеер живёт поверх всех routes).

import { useMiniPlayer } from "@/hooks/use-mini-player";

export function AudioPlayerEngine(): null {
	useMiniPlayer();
	return null;
}
